import SettingsPageLayout from './SettingsPageLayout'

export default SettingsPageLayout
